

import React from "react";
import "./paramedical.css";
import InquiryForm from "../InquiryForm";

const ParamedicalCareerAustralia = () => {
  return (
    <div className="career-container">
      <h1 className="career-title">Paramedical Career in Australia</h1>

      {/* Overview */}
      <div className="career-card animate-fade">
        <h2>Overview</h2>
        <p>
          Paramedical roles in Australia are in high demand across state ambulance
          services, mining sites, and private clinics. Salaries range from{" "}
          <b>$80,000 to $140,000+</b> depending on the role and location.
          Practitioners must register with AHPRA, and international applicants
          often need to pass a strict skills assessment.
        </p>
      </div>

      {/* Qualifications */}
      <div className="career-card animate-slide">
        <h2>Qualifications and Registration</h2>
        <p>
          <b>AHPRA Registration:</b> Paramedicine is a nationally regulated
          profession in Australia. All practicing paramedics must be registered
          with the Australian Health Practitioner Regulation Agency (AHPRA).
        </p>
        <p>
          <b>Degrees & Diplomas:</b> To gain registration, you typically need an
          approved Bachelor's degree in Paramedicine or equivalent prior
          qualifications (such as a Diploma of Paramedical Science).
        </p>
      </div>

      {/* Direct Jobs */}
      <div className="career-card animate-fade">
        <h2>Direct Paramedic Jobs Are Difficult</h2>
        <ul>
          <li>You must be registered with AHPRA (Australian Health Practitioner Regulation Agency).</li>
          <li>Need a Bachelor's degree in Paramedicine.</li>
          <li>Registration required to legally work.</li>
        </ul>
      </div>

      {/* Licensing */}
      <div className="career-card animate-slide">
        <h2>Licensing & Registration</h2>
        <p>To work as a paramedic, you need:</p>
        <ol>
          <li>Recognized qualification (Bachelor's degree)</li>
          <li>Registration with Paramedicine Board (via AHPRA)</li>
          <li>Skills assessment (VETASSESS for migration)</li>
          <li>English test (IELTS / OET)</li>
        </ol>
      </div>

      {/* Visa Pathways */}
      <div className="career-card animate-fade">
        <h2>Visa Pathways</h2>
        <p>Main visa options:</p>
        <ul>
          <li>Skilled Visa (Subclass 189 / 190 / 491)</li>
          <li>Employer-sponsored visa (Subclass 482)</li>
          <li>Requires job offer + salary threshold (~AUD 76,515)</li>
        </ul>
      </div>

    

      <InquiryForm title="Inquire About Australia Programs" />
      <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>

    </div>
  );
};

export default ParamedicalCareerAustralia;